let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ygSW")).then(() => parcelRequire('i9zBn'));